<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-container>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="question.questionTypeId"
                  :items="question_types"
                  outlined
                  item-text="name"
                  item-value="id"
                  label="Question Type"
                  placeholder="Select a question type"
                  :rules="[$rules.required]"
                  hide-details="auto"
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  v-model="question.question"
                  label="Question"
                  :rules="[$rules.required]"
                  maxlength="250"
                  hide-details="auto"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="question.sectionId"
                  :items="annual_review_sections"
                  outlined
                  item-text="title"
                  item-value="id"
                  label="Question Section"
                  :rules="[$rules.required]"
                  hide-details="auto"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-btn color="secondary" x-large @click="save" :loading="saving">
          {{ saveText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EditAnnualReviewQuestionDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    search: "",
    valid: false,
    loading: false,
    saving: false,
    question: {}
  }),
  watch: {},
  computed: {
    isAdd() {
      return !this.question.id;
    },
    title() {
      return !this.isAdd ? "Edit Question" : "Add a new question";
    },
    saveText() {
      return !this.isAdd ? "Save" : "Add Question";
    },
    question_types() {
      return this.survey_question_types.filter(
        x => x.id != this.$enums.questionTypes.MULTIPLE_CHOICE
      );
    },
    ...mapGetters({
      survey_question_types: "lookup/survey_question_types",
      annual_review_sections: "settings/annual_review_sections"
    })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.isAdd) {
          this.question.sortOrder =
            (
              (
                this.annual_review_sections.find(
                  x => x.id == this.question.sectionId
                ) || {}
              ).question || []
            ).length + 1;
        }
        this.saving = true;
        this.$store
          .dispatch("settings/saveAnnualReviewQuestion", this.question)
          .then(() => {
            this.$emit("save");

            this.$root.$snackbarSuccess("Question saved");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving a question."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    showDialog(question) {
      this.dialog = true;
      this.question = Object.assign({}, question || {});
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  }
};
</script>
